var path = '/modules/core/views/custom-iframe.tpl.html';
var html = "<div class=\"custom-iframe-container\">\n    <iframe ng-src=\"{{vm.currentIframe.url}}\" ng-if=\"vm.currentIframe\" id=\"custom-customer-iframe\"></iframe>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/core/views/custom-iframe.tpl.html
// module id = 2091
// module chunks = 1